import * as React from 'react';
import { cn } from '@/lib/utils';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning' | 'info' | 'glass';
}

const badgeVariants = {
  default: 'bg-cyan-500/20 text-cyan-300 border border-cyan-500/30',
  secondary: 'bg-slate-700/50 text-slate-300 border border-slate-600',
  destructive: 'bg-red-500/20 text-red-300 border border-red-500/30',
  outline: 'text-slate-300 border border-slate-600 bg-transparent',
  success: 'bg-green-500/20 text-green-300 border border-green-500/30',
  warning: 'bg-yellow-500/20 text-yellow-300 border border-yellow-500/30',
  info: 'bg-blue-500/20 text-blue-300 border border-blue-500/30',
  glass: 'bg-white/5 backdrop-blur-sm text-white border border-white/10',
};

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = 'default', ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-all',
          badgeVariants[variant],
          className
        )}
        {...props}
      />
    );
  }
);
Badge.displayName = 'Badge';

export { Badge, badgeVariants };